import { Dispatch, SetStateAction } from "react";
import { TaskDetail } from "./TaskDetail";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    taskId: number;
    setShowModal: Dispatch<SetStateAction<boolean>>;
}

export function TaskDetailModal({ taskId, setShowModal }: Props) {
    return (
        <div className="bg-white w-[500px] rounded">
            <div className="flex justify-end bg-gray-100 rounded">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>
            <div className="h-full">
                <TaskDetail taskId={taskId}/>
            </div>
        </div>
    );
}